import React, { useState } from "react";

const RadioBtn = ({ onClick,checked }) => {


  return (
        <div className="relative flex flex-col items-center justify-center overflow-hidden">
          <div className="flex">
            <label className="inline-flex relative items-center mr-2 cursor-pointer">
              <input
                type="checkbox"
                className=" sr-only peer"
                checked={checked}
                readOnly
              />
              <div
                onClick={onClick}
                className=" w-10 h-6 bg-neutral-30 rounded-full p-1 left-0  peer-checked:after:translate-x-full after:absolute after:top-1 after:left-[3px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-gradient-to-r from-green to-dark"
              ></div>
            </label>
          </div>
        </div>
    
  );
};

export default RadioBtn;
